import ApiManager from '../api/manager';

class StockNotificationMailer {
  constructor(options = {}) {
    this.config = {
      moduleList: () => document.querySelectorAll('[data-module=js-stock-notification-mailer]'),
      apiManager: new ApiManager(),
      ...options
    };
  }

  init() {
    const { moduleList, apiManager } = this.config;

    moduleList().forEach(module_ => {
      const module = module_;
      if (module.dataset.initialized) return;

      module.dataset.initialized = true;

      const form = module.querySelector('form');

      form.addEventListener('submit', event => {
        event.preventDefault();
        const itemCode = form.elements.itemcode.value;
        const email = form.elements.Email.value;

        if (!itemCode || !email) return;

        const postData = {
          ProductId: itemCode,
          EmailAddress: email
        };

        apiManager
          .post('/api/v3/stocknotifications', postData)
          .then(() => {
            form.elements.Email.value = '';
            const text = module.querySelector('.c-stock-notification__text');
            if (!text) return;
            text.remove();
          })
          .catch(err => {
            console.error(err);
          });
      });
    });
  }
}

export default StockNotificationMailer;
